import script from "./LevelsBar.vue?vue&type=script&setup=true&lang=js"
export * from "./LevelsBar.vue?vue&type=script&setup=true&lang=js"

import "./LevelsBar.vue?vue&type=style&index=0&id=9bd9397e&lang=scss&scoped=true"

import exportComponent from "/Users/oleksandrpolishchuk/Documents/dev/eye-test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bd9397e"]])

export default __exports__